<template lang="pug">
  v-dialog(v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition")
    v-btn(v-if="dialogType === 'form'" slot="activator" dark color="indigo" title='View Detail')
      v-icon print
      | &nbsp; Print Preview
    v-icon(v-if="dialogType !== 'form'" slot="activator" small class='mr-2' title='View Detail' color="blue") remove_red_eye
    v-card
      v-toolbar(dark dense color="red" class="navFixed")
        v-toolbar-title IM Preview 
        v-spacer
        v-toolbar-items
          v-btn(v-if="dialogType !== 'user' && imItems.imStatus == 2 && imItems.imStatusLabel === i18n.status[9].name" flat @click="forwardDialog = true")
            v-icon forward
            | &nbsp; Forward
          v-dialog(v-model="forwardDialog" persistent max-width="500px")
            v-card()
              v-card-title(class="headline grey lighten-2") IM Forward
              v-card-text
                v-layout(wrap)
                  v-flex(xs12 v-if="approval == 3" style="color:#ff2c03;") User tujuan forward
                  v-flex( xs12)
                    v-autocomplete(
                      v-model="userForward"
                      label="Select User"
                      :items="users"
                      color="blue-grey lighten-2"
                      item-text="name"
                      item-value="data"
                      return-object
                      chips
                      clearable
                      solo
                    )
                      template(v-slot:selection="data")
                        v-chip(:input-value="data.selected" color="blue-grey" class="white--text" v-on="on") {{data.item.name ? data.item.name : data.item.fullname}}
                      template(v-slot:item="data")
                        template
                          v-list-tile-content
                            v-list-tile-title(v-html="data.item.name ? data.item.name : data.item.fullname")
                            v-list-tile-sub-title(v-html="data.item.title ? data.item.title : data.item.title")
                  v-flex(xs12)
                    v-textarea(
                      v-model="forwardNote"
                      box
                      label="Comment (Optional)"
                      auto-grow
                      value=""
                    )
              v-card-actions
                v-spacer
                v-btn(color="blue darken-1" flat @click.native="forwardDialog = false") Close
                div(class="text-xs-center")
                  v-btn(:disabled="forwardDialog2" :loading="forwardDialog2" color="blue darken-1" flat @click="forwardDialog2 = true") Submit
                  v-dialog(
                    v-model="forwardDialog2"
                    hide-overlay
                    persistent
                    width="300")
                    v-card(color="primary" dark)
                      v-card-text Processing. Please wait!
                        v-progress-linear(indeterminate color="white" class="mb-0")
          v-btn(v-if="imItems.imFileLampiran" flat @click="download(imItems.imFileLampiran)" title="Download Lampiran")
            v-icon cloud_download
            | &nbsp; Lampiran
          v-btn(v-if="dialogType !== 'user' && (imItems.imStatus == 2 || imItems.imStatus == 3) && (imItems.imStatusLabel === i18n.status[9].name || imItems.imStatusLabel === i18n.status[3].name)" flat title='Approval' @click="approvalDialog = true" color="black" class="blink") 
            v-icon(title="Approval") assignment_turned_in
            | &nbsp;Approval
          v-dialog(v-if="dialogType !== 'user' && (imItems.imStatus == 2 || imItems.imStatus == 3) && (imItems.imStatusLabel === i18n.status[9].name || imItems.imStatusLabel === i18n.status[3].name)" v-model="approvalDialog" persistent max-width="500px")
            v-card()
              v-card-title(class="headline grey lighten-2") Approval Form
              v-card-text
                v-layout(wrap)
                  v-flex(xs12)
                    v-radio-group(v-model="approval" row)
                      v-radio(v-if="dialogType === 'ho' && imItems.imStatus != 3" label="Approve" color="success" value="4")
                      v-radio(v-if="dialogType != 'ho' && imItems.imStatus != 3" label="Approve" color="success" value="7")
                      v-radio(v-if="imItems.imStatus != 3" label=`Reject` color="red" value="8")
                      v-radio(label="Need Review" color="yellow darken-4" value="3")
                    span(v-if="approval == 3" style="color:#ff2c03;") Approval akan dimulai lagi dari approver yang dipilih!
                  v-flex(v-if="approval == 3" xs12)
                    v-select(
                      v-model="select"
                      :hint="jabatan"
                      :items="reviewer"
                      item-text="fullname"
                      item-value="fullname"
                      label="Select"
                      persistent-hint
                      return-object
                      single-line
                      dense)
                  v-flex(xs12)
                    v-textarea(
                      v-model="comment"
                      box
                      label="Comment (Optional)"
                      auto-grow
                      value=""
                    )
                  v-flex(v-if="dialogType === 'site'" xs12)
                    v-subheader(class="pa-0") File Uji Teknis
                    input(type="file" id="file" ref="file" v-on:change="handleFileUpload()" accept=".pdf, .doc, .docx")
              v-card-actions
                v-spacer
                v-btn(color="blue darken-1" flat @click.native="approvalDialog = false") Close
                div(class="text-xs-center")
                  v-btn(:disabled="!select.hasOwnProperty('id') && approval == 3" :loading="approvalDialog2" color="blue darken-1" flat @click="approvalDialog2 = true") Submit
                  v-dialog(
                    v-model="approvalDialog2"
                    hide-overlay
                    persistent
                    width="300")
                    v-card(color="primary" dark)
                      v-card-text Processing. Please wait!
                        v-progress-linear(indeterminate color="white" class="mb-0")
                  v-dialog(
                    v-model="dialogTg"
                    persistent
                    max-width="320px")
                    v-card(class="dialog-card")
                        v-card-actions(class="headline grey lighten-2"
                        primary-title)
                          v-list-tile
                            img(src="../assets/telegram_icon.png" style="margin:-10px" width="35px")
                          span(style="margin: 5px 0 0 10px") Information
                          v-spacer
                          v-list-tile
                            img(src="../assets/imemo_icon.png" width="80px")
                        v-card-text
                          h3(style="text-align: center; font-weight:normal;") IMemo saat ini sudah terintegrasi dengan Telegram, apakah anda ingin mendapatkan notif dari Telegram juga?
                          <br/>
                          input(style="margin-left: 5%" type="checkbox" id="tgCheckbox" v-model="tgDontRemind")
                          label(for="tgCheckbox" class="tgLbl") Don't Remind Me
                          v-card-actions
                            v-spacer
                            v-btn(color="blue darken-1" flat="flat" @click="tgRegister") Iya
                            v-btn(color="green darken-1" flat="flat" @click="tgDialogClose") Tidak
          v-btn(flat @click="imItems.imStatus==4||imItems.imStatus==8 ? print=true : printIM(imItems._id)")
            v-icon print
            | &nbsp; Print 
          v-dialog(v-model="print" persistent max-width="450px")
                v-card
                  v-card-title(class="headline grey lighten-2") Print Document
                  v-alert(:value='true' color="success")
                    h3(style="text-align: center; font-weight:normal") To save the trees, please think to share it rather than print.
                  v-flex(class="text-xs-center")
                    v-btn(flat @click="printIM(imItems._id); print = false;")
                      v-icon print
                      | &nbsp; Print
                    v-btn(flat @click="print = false; shareIM();")
                      v-icon share
                      | &nbsp; Share
                  v-spacer
                  v-flex(class="text-xs-right")
                    v-btn(color="blue darken-1" flat @click.native="print = false") Close
          v-btn(v-if="imItems.imStatus==4||imItems.imStatus==8" flat @click="shareIM()")
            v-icon share
            | &nbsp; Share 
          v-dialog(v-model="share" persistent max-width="350px")
            v-card
                v-card-title(class="headline grey lighten-2") Share
                v-flex(class="text-xs-center")
                  ShareNetwork(v-for="network in networks" :key="network.key" :network="network.network" :title="network.network=='whatsapp' ? 'Subject: '+ sharing.title+' \\nBody: \\n' : sharing.title " :url="shortenUrl" :description="sharing.description")
                    img(:src="network.img" width="80px" style="margin:20px 15px;")
                v-spacer
                v-flex(class="text-xs-right")
                  v-btn(color="blue darken-1" flat @click.native="share=false") Close
          v-btn(dark flat @click.native="dialog = false")
            v-icon(title="Close") cancel
            | &nbsp;Close
      v-list(three-line subheader class="print-bg padTop60")
        div(:id="imItems._id")
          .page(size="Auto")
            div(class="view-width" style="font-size:12px;")
              p(class="ma-0 display-1") {{ imItems.imGroup == 'bcg' ? 'PT. Berau Coal' : 'PT. GEMS' }}
              v-flex(ma-0 pa-0 xs12 d-flex)
                span(class="headline") CAPEX Approval
                span(class="headline print-header" v-if="imItems.imBudgeted") Budgeted ( {{imItems.imBudgeted}} )
                span(class="headline print-header" v-else="imItems.imBudgeted") Non-Budgeted
              hr(style="border-style: inset; border-width: 2px; margin-bottom: 1vh;")
              v-flex(mb-1)
                p(class="ma-0 subtitle-1") Project Title:
                p(class="font-weight-bold title") {{imItems.imPerihal}}
              v-layout(row wrap)
                v-flex(xs6) 
                  div(class="ma-0 subtitle-1") Creator:
                  div(class="font-weight-bold title") {{ imItems.imUser.fullname }}
                v-flex(xs6 sm6 pl-3 v-if="imItems.imValue.value >= 100000")                        
                  p(v-show="projectOwner" class="ma-0 subtitle-1") Project Owner:
                  p(class="font-weight-bold title ma-0 pb-1") {{ projectOwner }}        
            div(class="view-width detail-wrap" style="position:relative;font-size:14px;")
              div(id="background")
                img(v-if="imItems.imStatus == 1" src="img/draft.png" class="imgWaterMark")
                img(v-if="imItems.imStatus == 2" src="img/on-approval.png" class="imgWaterMark")
                img(v-if="imItems.imStatus == 4" src="img/fully-approved.png" class="imgWaterMark")
                img(v-if="imItems.imStatus == 5" src="img/withdraw.png" class="imgWaterMark")
                img(v-if="imItems.imStatus == 8" src="img/rejected.png" class="imgWaterMark")
              table(class="view-width" border="1" style="border:1px solid black;border-collapse: collapse;text-align:center;z-index:100;")
                tbody
                  tr
                    td(colspan="3" style="") 
                      b Approved by,
                  tr
                    td(width="36%") 
                      b Name/Position
                    td(width="32%") 
                      b Comment
                    td(width="32%")
                      b Digital Signature
                  tr(v-for="(item, index) in imItems.imWorkflow" v-if="item.postAs == 'requestor' || item.postAs == 'budgetor' || item.postAs == 'approver' || item.postAs == 'bod'" height="80px")
                    td(width="40%" class="px-3")
                      b(v-if="item.fullname") {{ item.fullname }} / {{ item.title }}
                      b(v-else) {{ item.name }} / {{ item.title }}
                    //- td {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td(v-if="imItems.imStatus == 3")
                      div(v-if="imItems.imStatus == 3 && item.status == 3") Under Review
                      div(v-else-if="imItems.imStatus == 3 && item.id == imItems.imReturn[imItems.imReturn.length-1].id") 
                        //- | Returned to {{ imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname ? imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname : imItems.imReturn[imItems.imReturn.length-1].returnTo.name }}
                        //- br
                        | {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                        //- br
                        //- | (Need Reapproval)
                      div(v-else-if="imItems.imStatus == 3 && item.date && (item.status == 6 || item.status == 9)") 
                        | {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                        //- br
                        //- | (Need Reapproval)
                      div(v-else) {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td(v-else-if="imItems.imStatus !=3 && imItems.hasOwnProperty('imReturn')")
                      div(v-if="imItems.imStatus == 2 && item.id == imItems.imReturn[imItems.imReturn.length-1].id && item.status != 7") 
                        //- | Returned to {{ imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname ? imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname : imItems.imReturn[imItems.imReturn.length-1].returnTo.name }}
                        //- br
                        | {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                        //- br
                        //- | (Need Reapproval)
                      div(v-if="imItems.imStatus == 8 && item.id == imItems.imReturn[imItems.imReturn.length-1].id && item.status != 7") 
                        //- | Returned to {{ imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname ? imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname : imItems.imReturn[imItems.imReturn.length-1].returnTo.name }}
                        //- br
                        | {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                      div(v-else-if="imItems.imStatus == 2 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length-1].id") 
                        | {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                        //- br
                        //- | (Need Reapproval)
                      div(v-else-if="imItems.imStatus == 8 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length-1].id") 
                        | {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                        //- br
                      div(v-else) {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td(v-else)
                      div {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                    td
                      div(v-if="item.status == 7" class="approved") 
                        img(src="../assets/check-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                      div(v-else-if="imItems.imStatus == 3 && item.date" class="approved") 
                        | {{ getTanggal(item.date) }}
                        br
                        | (Need Reapproval)
                      div(v-else-if="item.status == 8" class="approved") 
                        img(src="../assets/close-64.png" style="width:25px;")
                        br
                        | {{ getTanggal(item.date) }}<br />
                      div(v-else-if="imItems.imStatus == 2 && imItems.hasOwnProperty('imReturn') && item.date" class="approved")
                        | {{ getTanggal(item.date) }}
                        br
                        | (Need Reapproval)
                      div(v-else-if="imItems.imStatus == 8 && imItems.hasOwnProperty('imReturn') && item.date" class="approved")
                        | {{ getTanggal(item.date) }}
                      div(v-else class="approved ff0000") &nbsp; <br />&nbsp; <br />&nbsp; <br />
              //- br
              //- span(style="font-size:14px;font-weight:bold;color:red;") Scan QR code to validate the correctness of information regarding the digital signatures on this document.
              //- p
              //-   img(:src="`${API_URL}/qr/generate/${imItems.imNo}/${imItems.imType}`" style="vertical-align:middle;width:150px;")
            div(class="view-width pagebreak" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 1. Executive Summary
              div(v-html="imItems.imExecutiveSummary" class="ck-content ml-3")
            div(class="view-width" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 2. Background
              div(v-html="imItems.imLatarBelakang" class="ck-content  ml-3")
            div(class="view-width" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 3. Project goals, objectives and expected benefits
              div(v-html="imItems.imTujuan" class="ck-content ml-3")
            div(class="view-width" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 4. Scope
              div(v-html="imItems.imScope" class="ck-content ml-3")
            div(class="view-width" style="text-align:justify;margin-top:15px;margin-bottom:26px;")
              h4(style="font-size:15px;") 5. Overview and rational of investment
              table(class="view-width ml-3" border="1" style="border:1px solid black;border-collapse: collapse;text-align: left;z-index:100;")
                tbody
                  tr
                    td(width="30%" class="pa-2") 
                      b Project Description
                    td(width="60%" class="pa-2") 
                      p {{ imItems.imOverview.projectDesc }}
                  tr
                    td(class="pa-2")
                      b Reason investment needed including the benefits (incl. non financial benefit)
                    td(class="pa-2")
                      p {{ imItems.imOverview.reasonInvestment }}
                  tr
                    td(class="pa-2")
                      b Key permits / approvals needed
                    td(class="pa-2")
                      p {{ imItems.imOverview.keyPermit }}
                  tr
                    td(class="pa-2")
                      b Partners / suppliers
                    td(class="pa-2")
                      p {{ imItems.imOverview.partners }}
                  tr
                    td(class="pa-2")
                      b Timescale
                    td(class="pa-2")
                      p {{ imItems.imOverview.timescale }}
                  tr
                    td(class="pa-2")
                      b Location / site
                    td(class="pa-2")
                      p {{ imItems.imOverview.location }}
                  tr
                    td(class="pa-2")
                      b Fit with Company Strategy
                    td(class="pa-2")
                      p {{ imItems.imOverview.isFit }}
                  tr
                    td(class="pa-2")
                      b Expansionary or Sustaining capex? Please state how much additional tonnage if expansionary
                    td(class="pa-2")
                      p {{ imItems.imOverview.isExpansionary }}
                  tr
                    td(class="pa-2")
                      b Impact on cost per ton
                    td(class="pa-2")
                      p {{ imItems.imOverview.impactCost }}
                  tr
                    td(class="pa-2")
                      b Describe how the project fits into the current approved mine plan
                    td(class="pa-2")
                      p {{ imItems.imOverview.isFitMinePlan }}
            div(class="view-width" style="text-align:justify;")
              h4(style="font-size:15px;") 6. Project Cost
              table(class="view-width ml-3" border="1" style="border:1px solid black;border-collapse: collapse;text-align: left;z-index:100;")
                tbody
                  tr
                    td(width="30%" class="pa-2") 
                      b Project Cost ($)
                    td(width="60%" class="pa-2") 
                      p {{ imItems.imValue.currency }} {{ getFormatCurrency(imItems.imValue.value) }}
                  tr
                    td(class="pa-2")
                      b NPV @ 12%
                    td(class="pa-2")
                      p {{ imItems.imValue.npv }}
                  tr
                    td(class="pa-2")
                      b IRR
                    td(class="pa-2")
                      p {{ imItems.imValue.irr }}
                  //- tr
                  //-   td(class="pa-2")
                  //-     b Return on investment
                  //-   td(class="pa-2")
                  //-     p {{ imItems.imValue.roi }}
                  tr
                    td(class="pa-2")
                      b Cash Payback Period (Years)
                    td(class="pa-2")
                      p {{ imItems.imValue.cashbackPeriod }}
                  tr
                    td(class="pa-2")
                      b Describe how the project will be financed
                    td(class="pa-2")
                      p {{ imItems.imValue.howFinanced }}
            div(class="view-width" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 7. Opportunities and risks
              table(class="view-width ml-3" border="1" style="border:1px solid black;border-collapse: collapse;text-align: left;z-index:100;")
                tbody
                  tr
                    td(width="30%" class="pa-2") 
                      b Opportunity
                    td(width="60%" class="pa-2") 
                      div(v-html="imItems.imOpportunity")
                  tr
                    td(class="pa-2")
                      b Risk
                    td(class="pa-2")
                      div(v-html="imItems.imRisk")
            div(class="view-width" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 8. Alternative options
              div(class="view-width ml-3") Please describe whether any alternative options were considered and why you are proposing this particular solution. Also, please state the impact of not progressing with any option.
              table(class="view-width ml-3" border="1" style="border:1px solid black;border-collapse: collapse;text-align: left;z-index:100;")
                tbody
                  tr
                    td(width="30%" class="pa-2") 
                      b Do nothing
                    td(width="60%" class="pa-2") 
                      div(v-html="imItems.imDoNothing")
                  tr
                    td(class="pa-2")
                      b Alternative Option
                    td(class="pa-2")
                      div(v-html="imItems.imAltOption")
            div(class="view-width" v-if="imItems.imValue.value >= 100000" style="text-align:justify;margin-top:15px;")
              h4(style="font-size:15px;") 9. Project Team
              div(class="view-width detail-wrap" style="position:relative;font-size:14px;")
                div(id="background")
                  img(v-if="imItems.imStatus == 1" src="img/draft.png" class="imgWaterMark")
                  img(v-if="imItems.imStatus == 2" src="img/on-approval.png" class="imgWaterMark")
                  img(v-if="imItems.imStatus == 4" src="img/fully-approved.png" class="imgWaterMark")
                  img(v-if="imItems.imStatus == 5" src="img/withdraw.png" class="imgWaterMark")
                  img(v-if="imItems.imStatus == 8" src="img/rejected.png" class="imgWaterMark")
                table(class="view-width ml-3" border="1" style="border:1px solid black;border-collapse: collapse;text-align:center;z-index:100;")
                  tbody
                    tr
                      td(width="30%") 
                        b Name/Position
                      td(width="30%") 
                        b Comment
                      td(width="30%")
                        b Signature
                    tr(v-for="(item, index) in imItems.imWorkflow" v-if="item.postAs == 'projectTeam'" height="80px")
                      td(width="40%" class="px-3 pt-1" style="text-align:left")
                        b {{item.positionAs}}
                        br
                        p(v-if="item.fullname") {{ item.fullname }} / {{ item.title }}
                        p(v-else) {{ item.name }} / {{ item.title }}
                      //- td {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                      td(v-if="imItems.imStatus == 3")
                        div(v-if="imItems.imStatus == 3 && item.status == 3") Under Review
                        div(v-else-if="imItems.imStatus == 3 && item.id == imItems.imReturn[imItems.imReturn.length-1].id") 
                          //- | Returned to {{ imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname ? imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname : imItems.imReturn[imItems.imReturn.length-1].returnTo.name }}
                          //- br
                          | {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                          //- br
                          //- | (Need Reapproval)
                        div(v-else-if="imItems.imStatus == 3 && item.date && (item.status == 6 || item.status == 9)") 
                          | {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                          //- br
                          //- | (Need Reapproval)
                        div(v-else) {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                      td(v-else-if="imItems.imStatus !=3 && imItems.hasOwnProperty('imReturn')")
                        div(v-if="imItems.imStatus == 2 && item.id == imItems.imReturn[imItems.imReturn.length-1].id && item.status != 7") 
                          //- | Returned to {{ imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname ? imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname : imItems.imReturn[imItems.imReturn.length-1].returnTo.name }}
                          //- br
                          | {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                          //- br
                          //- | (Need Reapproval)
                        div(v-if="imItems.imStatus == 8 && item.id == imItems.imReturn[imItems.imReturn.length-1].id && item.status != 7") 
                          //- | Returned to {{ imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname ? imItems.imReturn[imItems.imReturn.length-1].returnTo.fullname : imItems.imReturn[imItems.imReturn.length-1].returnTo.name }}
                          //- br
                          | {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                        div(v-else-if="imItems.imStatus == 2 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length-1].id") 
                          | {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                          //- br
                          //- | (Need Reapproval)
                        div(v-else-if="imItems.imStatus == 8 && item.date && (item.status == 6 || item.status == 9) && item.id != imItems.imReturn[imItems.imReturn.length-1].id") 
                          | {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined) ? item.comment : '-' }}
                          //- br
                        div(v-else) {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                      td(v-else)
                        div {{ (item.comment !== null && item.comment !== '' && item.comment !== undefined && item.status != 6 && item.status != 3 && item.status != 9) ? item.comment : '' }}
                      td
                        div(v-if="item.status == 7" class="approved") 
                          img(src="../assets/check-64.png" style="width:25px;")
                          br
                          | {{ getTanggal(item.date) }}<br />
                        div(v-else-if="imItems.imStatus == 3 && item.date" class="approved") 
                          | {{ getTanggal(item.date) }}
                          br
                          | (Need Reapproval)
                        div(v-else-if="item.status == 8" class="approved") 
                          img(src="../assets/close-64.png" style="width:25px;")
                          br
                          | {{ getTanggal(item.date) }}<br />
                        div(v-else-if="imItems.imStatus == 2 && imItems.hasOwnProperty('imReturn') && item.date" class="approved")
                          | {{ getTanggal(item.date) }}
                          br
                          | (Need Reapproval)
                        div(v-else-if="imItems.imStatus == 8 && imItems.hasOwnProperty('imReturn') && item.date" class="approved")
                          | {{ getTanggal(item.date) }}
                        div(v-else class="approved ff0000") &nbsp; <br />&nbsp; <br />&nbsp; <br />  
            p(class="ma-0 pt-2" style="font-size:14px;font-weight:bold;color:red;") Scan QR code to validate the correctness of information regarding the digital signatures on this document.
            p(class="ma-0 pa-0")
              img(class="ma-0 pa-0" :src="'data:image/png;base64, '+imItems.qrcode" style="vertical-align:middle;width:150px;")        
</template>

<script>
import axios from 'axios';
import md5 from 'md5';
import { mapState } from "vuex";
import * as i18n from "../data/i18n.json";
export default {
  name: "ProposalView",
  props: {
    dialogType: String,
    imItems: Object,
    userDetail: Object
  },
  data: () => ({
    i18n: i18n.default,
    dialog: false,
    approvalBtn: false,
    approvalDialog: false,
    approvalDialog2: false,
    dialogTg: false,
    tgDontRemind: false,
    comment: null,
    approvalflag: false,
    approval: null,
    select: {},
    print:false,
    share:false,
    forwardNote: null,
    userForward: {},
    forwardDialog: false,
    forwardDialog2: false,
    users: [],
    projectOwner: ''
  }),
  computed: {
    ...mapState(["API_URL", "WE_URL", "sharing", "networks","shortenUrl","dataUsers"]),
    getWithdrawDate:function() {
      let result = '';
      for(const item of this.imItems.imWorkflow) {
        if (item.status == 5) {
          result = item.date;
          break;
        }
      }
      return result;
    },
    reviewer: function() {
      let result = [];
      result.push(this.imItems.imUser);
      for (const wf of this.imItems.imWorkflow) {
        if(typeof wf.fullname === 'undefined'){
          this.$set(wf, 'fullname', wf.name);
        }
        if (wf.status == 9 || wf.status == 3)  break;
        result.push(wf);
      }
      return result;
    },
    jabatan: function() {
      if(this.select === this.imItems.imUser){
        return this.select.title + ' (Initiator)';
      }
      return this.select.title;
    },
    titleUser: function() {
      return this.userForward.title;
    }
  },
  mounted: async function() {
    if (!this.approvalflag) {
      if (this.dialogType === 'ho') {
        this.approvalflag  = true;
        this.approval = this.imItems.imStatus == 3 ? '3' : '4';
      } else {
        this.approvalflag  = true;
        this.approval = this.imItems.imStatus == 3 ? '3' : '7';
      }
    }
    let userDatas = await this.getUsers();
    for (const item of userDatas.data) {
      this.users.push(item);
    }
    for (const item of this.imItems.imWorkflow) {
      if(item.positionAs == 'Project Owner') this.projectOwner = item.name;
    }
  },
  methods: {
    getUsers: async function() {
      const config = {
        method: "get",
        url: `${this.WE_URL}/api/user`,
        auth: {
          username: 'imemo',
          password: 'Ang3lT3n4n!#'
        },
      };
      const dataUser = await axios(config);
      return dataUser;
    },
    printIM: function(id) {
      printJS({
        printable: id, 
        type: 'html',
        scanStyles: false,
        css: ["/stylesheets/approval.css", "/stylesheets/vuetify.min.css", "/stylesheets/ck-content.css"]
      });
    },
    getTanggal: function(tgl) {
      let monthNames = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
      let tanggal = new Date(tgl);
      let month = tanggal.getMonth();
      let date = tanggal.getDate() < 10 ? '0'+tanggal.getDate() : tanggal.getDate();
      return date+' '+monthNames[month]+' '+tanggal.getFullYear();
    },
    download(files) {
      if (Array.isArray(files)) {
        for (const key in files) {
          window.open(`${this.API_URL}/fileupload/${files[key]}`, '_blank');
        }
      } else {
        window.open(`${this.API_URL}/fileupload/${files}`, '_blank');
      }
    },
    getFormatCurrency: function(value){
      const formatter = new Intl.NumberFormat({
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
      })
      return formatter.format(value);
    },
    shareIM:function(){
      this.$store.dispatch("getShortenUrl",{im:this.imItems,userDetail:this.userDetail}).then(()=>this.share=true)
    },
    tgRegister: function(){
      window.open(`https://t.me/itapps_smm_bot?start=${this.dataUsers.id}${md5(`${this.dataUsers.id}`)}`);
      location.reload()
    },
    tgDialogClose: async  function(){
      if(this.tgDontRemind){
        await axios.put(`${this.API_URL}/api/tele-notif`,{teleNotif: 0, id: this.dataUsers.id});
      }
      this.dialogTg = false;
      location.reload()
    },
  },
  watch: {
    approvalDialog2 (val) {
      if (!val) return
      if (this.dialogType === 'site') {
        let formData = new FormData();
        formData.append('_id', this.imItems._id);
        formData.append('status', parseInt(this.approval));
        formData.append('comment', this.comment);
        formData.append('attached', this.file);
        if(this.$route.name == `FE Request`){
          const config = {
            method: "put",
            url: `${this.API_URL}/forex/update/requests`,
            headers: {"Authorization": `Bearer ${this.$store.state.token}`, "Content-Type": "multipart/form-data"},
            data: formData
          };
          axios(config).then(res => {
            if (res.status == 200) {
              setTimeout(() => {
                  this.dialog2 = false;
                  this.dialog = false;
                  location.reload();
                },
              1000);
            }
          });
        }else{
          const config = {
            method: "put",
            url: `${this.API_URL}/api/update/requests`,
            headers: {"Authorization": `Bearer ${this.$store.state.token}`, "Content-Type": "multipart/form-data"},
            data: formData
          };
          axios(config).then(res => {
            if (res.status == 200) {
              setTimeout(() => {
                  this.dialog2 = false;
                  this.dialog = false;
                  location.reload();
                },
              1000);
            }
          });
        }
      } else {
        if(this.$route.name == `FE Request`){
          const config = {
            method: "put",
            url: `${this.API_URL}/forex/update/requests`,
            headers: {"Authorization": `Bearer ${this.$store.state.token}`},
            data: {_id: this.imItems._id, status: parseInt(this.approval), comment: this.comment, backto: parseInt(this.approval) == 3 ? this.select : null}
          };
          axios(config).then(res => {
            if (res.status == 200) {
              setTimeout(() => {
                  this.dialog2 = false;
                  this.dialog = false;
                  location.reload();
                },
              1000);
            }
          });
        }else{
          const config = {
            method: "put",
            url: `${this.API_URL}/api/update/requests`,
            headers: {"Authorization": `Bearer ${this.$store.state.token}`},
            data: {_id: this.imItems._id, status: parseInt(this.approval), comment: this.comment, backto: parseInt(this.approval) == 3 ? this.select : null}
          };
          axios(config).then(res => {
            if (res.status == 200) {
              axios.get(`${this.WE_URL}/api/user/${this.dataUsers.id}`).then(res2=>{
                const userdata = res2.data;
                let subscribedToTelegram = true;
                if(!userdata.telegram_id && userdata.teleNotif !== 0){
                  this.dialog2 = false;
                  this.dialog = false;
                  this.dialogTg = true;
                  subscribedToTelegram = false;
                }
                setTimeout(() => {
                    if(subscribedToTelegram){
                      this.dialog2 = false;
                      this.dialog = false;
                      location.reload();
                    }
                  },
                1000);
              })
            }
          });
        }        
      }
      
    },
    forwardDialog2 (val) {
      if (!val) return
      if(this.$route.name == `FE Request`){
        const config = {
          method: "post",
          url: `${this.API_URL}/forex/requests/forward`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, userId: this.userForward.nik, note: this.forwardNote, by: this.userDetail._id, reply: 0}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }else{
        const config = {
          method: "post",
          url: `${this.API_URL}/api/requests/forward`,
          headers: {"Authorization": `Bearer ${this.$route.params.token}`},
          data: {_id: this.imItems._id, userId: this.userForward.nik, note: this.forwardNote, by: this.userDetail._id, reply: 0}
        };
        axios(config).then(res => {
          if (res.status == 200) {
            setTimeout(() => {
                this.dialog2 = false;
                this.dialog = false;
                location.reload();
              },
            1000);
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.print-bg {
  background: rgb(204,204,204) !important;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  font-size: 11px;
  padding: 13px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}

.tgLbl {
  position: relative;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* The containerLbl */
.containerLbl {
  position: relative;
  padding-left: 20px;
  margin: 0 30px 0 10px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.containerLbl input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.containerLbl:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.containerLbl input:checked ~ .checkmark {
  background-color: #000000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.containerLbl input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.containerLbl .checkmark:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
  .page[size="Auto"] {
    width: auto;
    margin:0 auto;
    display:block;
    text-align:initial;
  }
  table { page-break-inside:auto; }
  tr    { page-break-inside:avoid; page-break-after:auto; }
  .pagebreak { page-break-before: always; } /* page-break-after works, as well */
  p { page-break-after: auto; page-break-before: auto; page-break-inside: avoid; }
  .image {padding: 5%; page-break-after: auto; page-break-before: auto; page-break-inside: avoid;}
  .table {page-break-after: auto; page-break-before: auto; page-break-inside: avoid;}
}
#background {
  position:absolute;
  z-index:0;
  display:block;
  top:0px;
  left:0px;
  text-align: right;
  width: 100%;
}
.imgWaterMark {
  width: 201px;
  position:absolute;
  top:0px;
  right:35px;
}
</style>